/**
 * Identity Hub create/confirm dialogs stay open on overlay click.
 * Escape and Cancel still close — this only blocks pointer dismiss.
 */
export function preventDismissOnOutside(event: { preventDefault: () => void }): void {
  event.preventDefault();
}

export const PREVENT_DISMISS_PROPS = {
  onInteractOutside: preventDismissOnOutside,
  onPointerDownOutside: preventDismissOnOutside,
} as const;
